import { createContext, useContext, useMemo, useState, useEffect, ReactNode } from 'react'

export namespace ChannelSpace {
  export type Type = 'web' | 'aos' | 'ios'
  export interface ChannelContextValue {
    channel: 'web' | 'aos' | 'ios'
    web: boolean
    aos: boolean
    ios: boolean
  }
}
// v1 버전 SaturnAppInterface => v2 버전 SaturnAosInterface
export const handleDeviceDetect = (): ChannelSpace.ChannelContextValue => {
  const aosDevice = !!window.SaturnAosInterface || !!window.SaturnAppInterface
  const iosDevice = !!window.webkit?.messageHandlers.SaturnIosInterface

  let os: 'web' | 'aos' | 'ios' = 'web'

  if (iosDevice) os = 'ios'
  else if (aosDevice) os = 'aos'

  return { channel: os, web: os === 'web', aos: os === 'aos', ios: os === 'ios' }
}

const { channel } = handleDeviceDetect()

const contextInitialValue: ChannelSpace.ChannelContextValue = {
  channel: channel,
  web: channel === 'web',
  aos: channel === 'aos',
  ios: channel === 'ios',
}

const ChannelContext = createContext<ChannelSpace.ChannelContextValue>(contextInitialValue)

export const ChannelContextProvider = ({ children }: { children: ReactNode }) => {
  const [channelInfo, setChannelInfo] =
    useState<ChannelSpace.ChannelContextValue>(contextInitialValue)

  useEffect(() => {
    const deviceInfo = handleDeviceDetect()
    setChannelInfo(deviceInfo)
  }, [])

  const value = useMemo(() => channelInfo, [channelInfo])

  return <ChannelContext.Provider value={value}>{children}</ChannelContext.Provider>
}

// Custom hook to access channel information in other components
export function useChannel() {
  return useContext(ChannelContext)
}
